import { connect } from 'react-redux';

import CalendarEventAdminAddScreen from '../components/CalendarEventAdminAddScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    partnershipActiveId: storage.get(findStorageType(), 'partnershipId'),
    isLoading: state.calendarEventsAdmin.get('isLoading'),
    success: state.calendarEventsAdmin.getIn(['form', 'success']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const CalendarEventAdminAddScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CalendarEventAdminAddScreen);

export default CalendarEventAdminAddScreenContainer;
